import script from "./CompaniesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompaniesView.vue?vue&type=script&lang=ts&setup=true"

import "./CompaniesView.vue?vue&type=style&index=0&id=84909250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84909250"]])

export default __exports__